import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Coins } from 'lucide-react';

export default function ArtikelGuenstigeGeschenke() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />Alle Ratgeber
          </Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4">
            <Calendar className="w-4 h-4" /><span>Februar 2026</span>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">
            Günstige Eid Geschenkideen unter 20 €
          </h1>
          <p className="text-lg text-white/80 leading-relaxed">
            Schöne Geschenke müssen nicht teuer sein! Hier findest du liebevolle Ideen für jedes Budget.
          </p>
        </div>
      </section>

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">
            Eid ist ein Fest der Freude und Großzügigkeit – aber das bedeutet nicht, dass du ein Vermögen 
            ausgeben musst. Die schönsten Geschenke kommen von Herzen, nicht aus dem Geldbeutel. Hier sind 
            über 20 Geschenkideen unter 20 €, die trotzdem Freude bereiten.
          </p>

          <div className="bg-[#D4C5A9]/20 border-2 border-[#D4C5A9] rounded-2xl p-6 mb-12">
            <div className="flex items-center gap-3 mb-3">
              <Coins className="w-6 h-6 text-[#4A5D4F]" />
              <h3 className="font-serif text-xl font-medium text-[#2C332E]">Budget-Übersicht</h3>
            </div>
            <div className="grid sm:grid-cols-3 gap-4 text-sm">
              <div className="text-center p-3 bg-white rounded-lg">
                <p className="font-medium text-[#2C332E]">Unter 5 €</p>
                <p className="text-[#4B5563]">6 Ideen</p>
              </div>
              <div className="text-center p-3 bg-white rounded-lg">
                <p className="font-medium text-[#2C332E]">5-10 €</p>
                <p className="text-[#4B5563]">8 Ideen</p>
              </div>
              <div className="text-center p-3 bg-white rounded-lg">
                <p className="font-medium text-[#2C332E]">10-20 €</p>
                <p className="text-[#4B5563]">8 Ideen</p>
              </div>
            </div>
          </div>

          <section className="mb-12">
            <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-6">Unter 5 € – Kleine Aufmerksamkeiten</h2>
            
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">1. Duftkerze (klein)</h4>
                  <p className="text-sm text-[#4B5563]">Orientalische Düfte wie Oud oder Rose schaffen Eid-Atmosphäre.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~3-5 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">2. Eid Mubarak Karte (handgemacht)</h4>
                  <p className="text-sm text-[#4B5563]">Eine persönlich gestaltete Karte mit liebevollen Worten.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~1-3 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">3. Datteln (kleine Packung)</h4>
                  <p className="text-sm text-[#4B5563]">Das klassische Eid-Geschenk – immer willkommen!</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~3-5 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">4. Räucherstäbchen</h4>
                  <p className="text-sm text-[#4B5563]">Oud, Sandelholz oder Amber – für ein duftendes Zuhause.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~2-4 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">5. Islamisches Lesezeichen</h4>
                  <p className="text-sm text-[#4B5563]">Mit arabischer Kalligraphie oder Duas.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~2-4 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">6. Schokolade (Halal)</h4>
                  <p className="text-sm text-[#4B5563]">Hochwertige Tafel oder kleine Pralinenschachtel.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~3-5 €</span>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-6">5-10 € – Durchdachte Geschenke</h2>
            
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">7. Tasbih (Gebetskette)</h4>
                  <p className="text-sm text-[#4B5563]">Einfache aber hochwertige Holz-Tasbih.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~5-8 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">8. Islamisches Malbuch für Kinder</h4>
                  <p className="text-sm text-[#4B5563]">Moscheen, Muster und islamische Motive zum Ausmalen.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~6-9 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">9. Tee-Set (orientalisch)</h4>
                  <p className="text-sm text-[#4B5563]">Marokkanischer Minztee oder Chai mit schöner Verpackung.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~7-10 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">10. Hijab-Pins Set</h4>
                  <p className="text-sm text-[#4B5563]">Elegante Nadeln mit Perlen oder Kristallen.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~5-10 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">11. Attar-Öl (klein)</h4>
                  <p className="text-sm text-[#4B5563]">Konzentriertes Parfümöl in kleiner Flasche.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~8-10 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">12. Eid-Dekoration</h4>
                  <p className="text-sm text-[#4B5563]">Banner, Luftballons oder Lichterkette.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~5-10 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">13. Süßigkeiten-Mix (orientalisch)</h4>
                  <p className="text-sm text-[#4B5563]">Baklava, Lokum oder Ma'amoul vom türkischen Supermarkt.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~5-10 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">14. Dua-Buch</h4>
                  <p className="text-sm text-[#4B5563]">Sammlung von Bittgebeten für den Alltag.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~6-10 €</span>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-6">10-20 € – Hochwertige Geschenke</h2>
            
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">15. Kinderbuch "Mama, was ist Ramadan?"</h4>
                  <p className="text-sm text-[#4B5563]">Liebevolles Kinderbuch über Ramadan und Eid.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~15 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">16. Premium-Datteln (Medjool)</h4>
                  <p className="text-sm text-[#4B5563]">Hochwertige Datteln in schöner Geschenkbox.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~12-18 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">17. Gebetsteppich (einfach)</h4>
                  <p className="text-sm text-[#4B5563]">Schöner, faltbarer Gebetsteppich für unterwegs.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~15-20 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">18. Schmuck (dezent)</h4>
                  <p className="text-sm text-[#4B5563]">Einfache Kette oder Armband mit islamischem Motiv.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~12-20 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">19. Bastelset für Kinder</h4>
                  <p className="text-sm text-[#4B5563]">Eid-Karten, Laternen oder Dekoration selbst gestalten.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~15-20 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">20. Pflegeset (klein)</h4>
                  <p className="text-sm text-[#4B5563]">Handcreme, Lippenbalsam und Duft in schöner Box.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~15-20 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">21. Kunstdruck (islamisch)</h4>
                  <p className="text-sm text-[#4B5563]">Kalligraphie oder Moschee-Motiv für die Wand.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~10-18 €</span>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 flex justify-between items-start">
                <div>
                  <h4 className="font-medium text-[#2C332E] mb-1">22. Spielzeug für Kinder</h4>
                  <p className="text-sm text-[#4B5563]">Puzzle, Memory oder kleines Spielset.</p>
                </div>
                <span className="text-[#4A5D4F] font-medium text-sm">~10-20 €</span>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Bonus: Kostenlose Geschenke</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="space-y-2 text-[#4B5563]">
                <li>• <strong>Handgeschriebener Brief</strong> – Sag, warum diese Person wichtig ist</li>
                <li>• <strong>Gemeinsame Zeit</strong> – Ein Ausflug, Spieleabend oder Kochen</li>
                <li>• <strong>Dua</strong> – Ein aufrichtiges Bittgebet für den Beschenkten</li>
                <li>• <strong>Hilfe anbieten</strong> – Kochen, Aufräumen, Kinderbetreuung</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">
              Ein gutes Geschenk muss nicht teuer sein. Mit 5-20 € kannst du viel Freude bereiten – 
              wenn du das Richtige für die richtige Person wählst. Denk daran: Die Intention zählt mehr als der Preis.
            </p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/luxus-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ Luxus-Eid-Geschenke</Link></li>
              <li><Link to="/ratgeber/diy-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ DIY Eid Geschenke</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">
              Jetzt stöbern<Gift className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </article>
    </main>
  );
}
